module.exports = __webpack_public_path__ + "img/Jump Casting94.02bfa7bb.jpg";